import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { OrganizationFacade } from '../../../../shared/state/organization/facades/organization.facade';
import { ADD_ORGANIZATION_MODAL_ID } from '../../constants/organization-constants';
import { IOrganizationCreate } from '../../../../shared/models/organization';
import { DialogService } from '../../../../shared/services/dialog.service';
import { FontAwesomeSharedModule } from '../../../../shared/font-awesome/font-awesome';

@Component({
  selector: 'app-add-organization-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeSharedModule],
  templateUrl: './add-organization-modal.component.html',
})
export class AddOrganizationModalComponent implements OnInit {
  private fb = inject(FormBuilder);
  private organizationFacade = inject(OrganizationFacade);
  private dialogService = inject(DialogService);

  addOrganizationForm!: FormGroup;
  modalId = ADD_ORGANIZATION_MODAL_ID;

  ngOnInit(): void {
    this.addOrganizationForm = this.fb.group({
      display_name: ['', Validators.required],
      default_approve_analytical_dataset_requests: false,
      request_guidelines_enabled: false,
      request_guidelines_catalog_text: [''],
      request_guidelines_modal_text: [''],
      request_guidelines_url: [''],
    });
  }

  closeAddOrganizationModal() {
    this.dialogService.close(ADD_ORGANIZATION_MODAL_ID);
  }

  onSubmit() {
    if (this.addOrganizationForm.invalid) return;
    const formValue = this.addOrganizationForm.value;
    const organizationPayload: IOrganizationCreate = {
      display_name: formValue.display_name,
      default_approve_analytical_dataset_requests: formValue.default_approve_analytical_dataset_requests ?? false,
      request_guidelines_enabled: formValue.request_guidelines_enabled ?? false,
      request_guidelines_catalog_text: formValue.request_guidelines_catalog_text ?? '',
      request_guidelines_modal_text: formValue.request_guidelines_modal_text ?? '',
      request_guidelines_url: formValue.request_guidelines_url ?? '',
    };
    this.organizationFacade.createOrganization(organizationPayload);
    this.dialogService.close(ADD_ORGANIZATION_MODAL_ID);
    this.addOrganizationForm.reset();
  }
}
